export class ShifttypeConstraint {
    id: number;
    type: string;
    shifttype1: number;
    shifttype2: number;
}
